import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "balls-event-trig",
  "use": "balls-event-trig-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"balls-event-trig\"><path d=\"M28 18.14V4h-2v14.14a4 4 0 102 0zM27 24a2 2 0 112-2 2 2 0 01-2 2z\" /><path d=\"M20 18.14V4h-2v14.14a4 4 0 102 0zM19 24a2 2 0 112-2 2 2 0 01-2 2zM10.46 16.87L15.92 4.4l-1.84-.8-5.45 12.46A4.34 4.34 0 008 16a4 4 0 102.46.87zM8 22a2 2 0 112-2 2 2 0 01-2 2zM2.29 9.71l1.415-1.414 2.998 2.999-1.414 1.414z\" /><path d=\"M1.292 13.706l1.414-1.414 2.998 2.998-1.414 1.414z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/balls-event-trig.svg
// module id = j+gG
// module chunks = 39 44